
export function setSessionStorage (key, value) {
  const data = JSON.parse(sessionStorage.getItem('vue-session-key'))
  data[key] = value
  sessionStorage.setItem('vue-session-key', JSON.stringify(data))
}

export function getSessionStorage (key) {
  const data = JSON.parse(sessionStorage.getItem('vue-session-key'))
  return data[key]
}


export function getToken () {
  return getSessionStorage('token')
}